import { err, ok, type Result } from '@aibi/shared';
import type { AIDiagnostic } from '../errors.js';
import type { AICoreLimits } from '../limits.js';
import { describeFindings, scanText } from './content-guards.js';

/** Sustituye caracteres de control (salvo tabulador y saltos de linea) por espacios. */
function stripControlCharacters(text: string): string {
  let result = '';
  for (const char of text) {
    const code = char.charCodeAt(0);
    const control =
      (code < 0x20 && code !== 0x09 && code !== 0x0a && code !== 0x0d) || code === 0x7f;
    result += control ? ' ' : char;
  }
  return result;
}

/**
 * Valida y normaliza el mensaje del usuario antes de construir contexto o llamar a un
 * proveedor: longitud, caracteres de control y contenido inseguro (SQL, codigo, URLs,
 * secretos). El diagnostico nunca repite el contenido rechazado.
 */
export function guardPrompt(prompt: string, limits: AICoreLimits): Result<string, AIDiagnostic> {
  const text = stripControlCharacters(prompt).replace(/\s+/g, ' ').trim();
  if (text === '') {
    return err({
      stage: 'input',
      code: 'UNRECOGNIZED_INTENT',
      path: 'prompt',
      message: 'Escriba una instruccion para el asistente.',
    });
  }
  if (text.length > limits.maxPromptLength) {
    return err({
      stage: 'input',
      code: 'LIMIT_EXCEEDED',
      path: 'prompt',
      message: `La instruccion supera ${String(limits.maxPromptLength)} caracteres.`,
    });
  }
  const kinds = scanText(text);
  if (kinds.length > 0) {
    return err({
      stage: 'input',
      code: 'UNSAFE_CONTENT',
      path: 'prompt',
      message: `La instruccion contiene contenido no permitido (${describeFindings(kinds)}). El asistente solo acepta lenguaje natural sobre el analisis.`,
    });
  }
  return ok(text);
}
